import { memo } from "react";
import { findObjectKeyByValue } from "../../utils/helpers/main";
import { Chip } from "@mui/material";
import { LeadStatusColor } from "../../utils/helpers/lead.helper";
import { LEAD_STATUS } from "../../utils/constants/lead.constants";

const LeadStatusComponent = memo(({ params, setParams }) => {
  return (
    <Chip
      size="small"
      color={LeadStatusColor(params.status)}
      label={findObjectKeyByValue(params.status, LEAD_STATUS)}
    />
  );
});
export default LeadStatusComponent;
